module.exports = __webpack_public_path__ + "img/heart_12_bj.3cfd0198.png";